import styled, { css } from 'styled-components';

import { ButtonProps } from '../Components/Button/Button';

const variantStyles = (theme: any, variant = 'primary') =>
  ({
    primary: css`
      color: ${theme.colors.white};
      background-color: ${theme.colors.purple};
    `,
    secondary: css`
      color: ${theme.colors.white};
      background-color: ${theme.colors.lightBlue};
    `,
    success: css`
      color: ${theme.colors.white};
      background: linear-gradient(180deg, #00c056 0%, #00bb54 13.02%, #009a45 100%);
    `,
    link: css`
      color: ${theme.colors.gray};
      background-color: transparent;
      width: unset;
    `,
    danger: css`
      background-color: ${theme.colors.red};
      color: ${theme.colors.white};
    `,
    white: css`
      background-color: ${theme.colors.white};
      color: ${theme.colors.purple};
    `,
    disabled: css`
      cursor: auto;
      transform: none;

      :active {
        cursor: auto;
        transform: none;
      }
    `,
  }[variant]);

export const ButtonStyled = styled.button<ButtonProps>`
  border-radius: 32px;
  border: none;
  width: ${({ width }) => `${width}px` || '200px'};

  height: ${({ height }) => `${height}px` || '58px'};
  font-weight: bold;
  margin: ${({ margin }) => `${margin}px` ?? '30px'};
  cursor: pointer;
  transition: 0.3s;
  position: relative;
  &:disabled {
    opacity: 0.6;
    box-shadow: none;
  }
  ${({ theme, variant }) => variantStyles(theme, variant)}
`;
